import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Subject } from 'rxjs';
import { MeddataNotification, NotificationMessage, NotificationStatus, UpdateNotificationRequest } from '../../../../models';
import { MeddataNotificationService, WorkContext } from '../../../../services';
import { NotificationSignalRService } from '../../../../services/signalrServices';

@Component({
  selector: 'meddata-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.css']
})
export class NotificationBarComponent implements OnInit {
  private readonly notifier: NotifierService;
  notifications: NotificationMessage[] = [];

  notificationsCount: Subject<number> = new Subject();
  constructor(private notificationSignalRService: NotificationSignalRService, private router: Router, notifierService: NotifierService, private notificationService: MeddataNotificationService, private workContext: WorkContext) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.notificationSignalRService.init();
    this.notificationSignalRService.messages
      .subscribe({
        next: (s: NotificationMessage) => {
          this.notifications.push(s);
          this.notifier.notify('success', s.message);
          this.notificationsCount.next(this.notifications.length);
        },
        error: (err) => { },
        complete: () => { },
      });

    this.load();
  }
  load() {
    this.notifications = [];
    const currentuserId = this.workContext.currentUser?.id;
    if (currentuserId) {
      this.notificationService.getRecipient(this.workContext.currentUser.id.toString())
        .subscribe({
          next: (data) => {
            if (data && data.length > 0) {
              data.forEach(f => {
                this.notifications.push(f);
              });
              this.notificationsCount.next(this.notifications.length);
            }
            else {
              this.notificationsCount.next(0);
            }
          },
          error: (err) => { },
          complete: () => { },
        });
    }
  }
  goto(item: MeddataNotification) {
    const status = NotificationStatus.Read;

    this.notificationService.update({ id: item.id, status: status } as UpdateNotificationRequest)
      .subscribe({
        next: (a) => {
          this.load();
          if (item.url) {
            if (item.url.startsWith('http')) {
              window.location.href = item.url;
            }
            else {
              this.router.navigateByUrl(item.url);
            }
          }
        },
        error: (e) => { },
        complete: () => {
        }
      });

  }

}
